import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

export default class extends Controller {
  connect() {
    const range = this.element.dataset.range;

    this.picker = flatpickr(this.element, {
      dateFormat: "Y-m-d",
      disableMobile: true,
      mode: "range",
      wrap: true,
      defaultDate: range ? range.split(" to ") : null,
    });
  }

  disconnect() {
    if (this.picker) this.picker.destroy();
  }
}
